import { render } from "./Room.vue?vue&type=template&id=e08005bc&scoped=true&ts=true"
import script from "./Room.vue?vue&type=script&lang=ts"
export * from "./Room.vue?vue&type=script&lang=ts"

import "./Room.vue?vue&type=style&index=0&id=e08005bc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e08005bc"]])

export default __exports__